module.exports = __webpack_public_path__ + "static/media/Institute-of-Industrial-Electronics-Engineering.c79202c6.jpg";